/* eslint-disable import/prefer-default-export */
import MsgUtil from '@/utils/message';

export const NOTIFY_DURATION = 2000;

/**
 * 기본 notification 설정 데이터를 반환한다.
 * @author Ju
 * @param  {Object} obj        [description]
 * @param  {String} action     [description]
 * @param  {Boolean} successful [description]
 * @return {Object}            [description]
 */
export function getBasicNotificationData(obj, action, successful) {
  return {
    title: `${action} 수행`,
    message: MsgUtil.getResultMsg('수행', `${obj.objName} 장비에 대한 ${action}`, successful),
    duration: NOTIFY_DURATION,
  };
}



// WEBPACK FOOTER //
// ./src/utils/hambuger-popup.js